module.exports = __webpack_public_path__ + "static/media/clock.94d0c719.svg";